import { AI_API_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedPolling } from '@eggplant/data-request'
import { useGetParamsWithSpaceId } from '../useGetParamsWithSpaceId'
import type {
  EnvironmentResponse,
  GetAgentsParams
} from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  params?: GetAgentsParams
  interval?: number
  isPolling: boolean
  children?: (environment: EnvironmentResponse[]) => ReactElement
}

const PollAiEnvironmentsRequest = ({
  params,
  interval = 5000,
  isPolling,
  children
}: Props) => {
  const url = `${AI_API_SERVICE}/agents`

  const { requestParams } = useGetParamsWithSpaceId(params)

  return (
    <AuthenticatedPolling<EnvironmentResponse[]>
      children={children}
      intervalMs={interval}
      isPolling={isPolling}
      params={requestParams}
      url={url}
    />
  )
}

export default PollAiEnvironmentsRequest
